import React from 'react'

export const CheckboxInput = ({item, isChecked, onToggle}) => {
  return (
    <div className="checkbox-field-wrapper">
      <label className="checkbox-field-label">
        <input type="checkbox" checked={isChecked} onChange={onToggle} />
        <span>{item.name}</span>
      </label>
    </div>
  )
}
